import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip, Typography } from "antd";
import { useTranslation } from "../../../../../../others/i18n.js";
/**
 * Renders a header component for untranslatable sections with title and tooltip.

 */ function UntranslatableHeader({ level = 5, style }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            display: "flex",
            alignItems: "center",
            marginBottom: 16,
            ...style
        },
        children: [
            /*#__PURE__*/ _jsx(Typography.Title, {
                level: level,
                style: {
                    margin: 0
                },
                children: t("Brand Names / Untranslatables")
            }),
            /*#__PURE__*/ _jsx(Tooltip, {
                title: t("Add brand names, product names, or other terms that should not be translated. These terms will be preserved during machine translation."),
                placement: "top",
                children: /*#__PURE__*/ _jsx(QuestionCircleOutlined, {
                    style: {
                        marginLeft: 8
                    }
                })
            })
        ]
    });
}
export { UntranslatableHeader };
